import * as Styled from "./LeadStaticField.styled";

const LeadStaticField = ({
  children
}) => {
  return (
    <Styled.LeadStaticFieldContainer>
      {children}
    </Styled.LeadStaticFieldContainer>
  )
}

export default LeadStaticField